"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.RestrictionType = exports.AuthorizedUserTypeEnum = exports.StateEnum = exports.StatusEnum = exports.ActionEnum = void 0;
var ActionEnum;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["ACTIVATE"] = "ACTIVATE";
    ActionEnum["BENEFITS_CHANGE"] = "BENEFITS_CHANGE";
    ActionEnum["CATEGORIES_CHANGE"] = "CATEGORIES_CHANGE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["CONTRACT_CHANGE"] = "CONTRACT_CHANGE";
    ActionEnum["DEACTIVATE"] = "DEACTIVATE";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["FRIENDLY_NAMES_CHANGE"] = "FRIENDLY_NAMES_CHANGE";
    ActionEnum["QUALIFYING_DELEGATES_CHANGE"] = "QUALIFYING_DELEGATES_CHANGE";
    ActionEnum["INTERNAL_NAME_CHANGE"] = "INTERNAL_NAME_CHANGE";
    ActionEnum["SUPPLEMENTS_CHANGE"] = "SUPPLEMENTS_CHANGE";
    ActionEnum["PRODUCT_TIERS_CHANGE"] = "PRODUCT_TIERS_CHANGE";
    ActionEnum["PRODUCT_VERSIONED"] = "PRODUCT_VERSIONED";
    ActionEnum["STATE_PROVINCE_RESTRICTION_CHANGE"] = "STATE_PROVINCE_RESTRICTION_CHANGE";
    ActionEnum["UPDATING_MARKETING_DATA"] = "UPDATING_MARKETING_DATA";
    ActionEnum["SUPPLEMENT_CONTRACT_CHANGE"] = "SUPPLEMENT_CONTRACT_CHANGE";
    ActionEnum["UPDATE_AREA_OF_LAW_IDS"] = "UPDATE_AREA_OF_LAW_IDS";
})(ActionEnum = exports.ActionEnum || (exports.ActionEnum = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["INACTIVE"] = "INACTIVE";
    StatusEnum["DELETE"] = "DELETE";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
var StateEnum;
(function (StateEnum) {
    StateEnum["AB"] = "AB";
    StateEnum["AK"] = "AK";
    StateEnum["AL"] = "AL";
    StateEnum["AR"] = "AR";
    StateEnum["AZ"] = "AZ";
    StateEnum["BC"] = "BC";
    StateEnum["CA"] = "CA";
    StateEnum["CA2"] = "CA_2";
    StateEnum["CO"] = "CO";
    StateEnum["CT"] = "CT";
    StateEnum["DC"] = "DC";
    StateEnum["DE"] = "DE";
    StateEnum["FL"] = "FL";
    StateEnum["GA"] = "GA";
    StateEnum["GU"] = "GU";
    StateEnum["HI"] = "HI";
    StateEnum["IA"] = "IA";
    StateEnum["ID"] = "ID";
    StateEnum["IL"] = "IL";
    StateEnum["IN"] = "IN";
    StateEnum["KS"] = "KS";
    StateEnum["KY"] = "KY";
    StateEnum["LA"] = "LA";
    StateEnum["LS"] = "LS";
    StateEnum["MA"] = "MA";
    StateEnum["MB"] = "MB";
    StateEnum["MD"] = "MD";
    StateEnum["ME"] = "ME";
    StateEnum["MI"] = "MI";
    StateEnum["MN"] = "MN";
    StateEnum["MO"] = "MO";
    StateEnum["MS"] = "MS";
    StateEnum["MT"] = "MT";
    StateEnum["NB"] = "NB";
    StateEnum["NC"] = "NC";
    StateEnum["ND"] = "ND";
    StateEnum["NE"] = "NE";
    StateEnum["NF"] = "NF";
    StateEnum["NH"] = "NH";
    StateEnum["NJ"] = "NJ";
    StateEnum["NL"] = "NL";
    StateEnum["NM"] = "NM";
    StateEnum["NS"] = "NS";
    StateEnum["NT"] = "NT";
    StateEnum["NU"] = "NU";
    StateEnum["NV"] = "NV";
    StateEnum["NY"] = "NY";
    StateEnum["OH"] = "OH";
    StateEnum["OK"] = "OK";
    StateEnum["ON"] = "ON";
    StateEnum["OR"] = "OR";
    StateEnum["PA"] = "PA";
    StateEnum["PE"] = "PE";
    StateEnum["PR"] = "PR";
    StateEnum["QC"] = "QC";
    StateEnum["RI"] = "RI";
    StateEnum["SC"] = "SC";
    StateEnum["SD"] = "SD";
    StateEnum["SF"] = "SF";
    StateEnum["SK"] = "SK";
    StateEnum["TN"] = "TN";
    StateEnum["TX"] = "TX";
    StateEnum["UT"] = "UT";
    StateEnum["VA"] = "VA";
    StateEnum["VI"] = "VI";
    StateEnum["VT"] = "VT";
    StateEnum["WA"] = "WA";
    StateEnum["WI"] = "WI";
    StateEnum["WV"] = "WV";
    StateEnum["WY"] = "WY";
    StateEnum["YT"] = "YT";
})(StateEnum = exports.StateEnum || (exports.StateEnum = {}));
var AuthorizedUserTypeEnum;
(function (AuthorizedUserTypeEnum) {
    AuthorizedUserTypeEnum["PRIMARY"] = "PRIMARY";
    AuthorizedUserTypeEnum["SPOUSE"] = "SPOUSE";
    AuthorizedUserTypeEnum["DEPENDENT"] = "DEPENDENT";
    AuthorizedUserTypeEnum["NORMAL_USER"] = "NORMAL_USER";
    AuthorizedUserTypeEnum["OWNER"] = "OWNER";
    AuthorizedUserTypeEnum["CO_OWNER"] = "CO_OWNER";
    AuthorizedUserTypeEnum["SECONDARY"] = "SECONDARY";
    AuthorizedUserTypeEnum["TERTIARY"] = "TERTIARY";
    AuthorizedUserTypeEnum["ELDER"] = "ELDER";
    AuthorizedUserTypeEnum["ANY"] = "ANY";
    AuthorizedUserTypeEnum["ALL"] = "ALL";
})(AuthorizedUserTypeEnum = exports.AuthorizedUserTypeEnum || (exports.AuthorizedUserTypeEnum = {}));
var RestrictionType;
(function (RestrictionType) {
    RestrictionType["NOT_ALLOWED"] = "NOT_ALLOWED";
    RestrictionType["ALLOWED"] = "ALLOWED";
})(RestrictionType = exports.RestrictionType || (exports.RestrictionType = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://products.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Products Service Api
 * @version v1
 * @baseUrl https://products.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Products
             * @name ProductsGetProducts
             * @request GET:/v1/products
             * @secure
             */
            productsGetProducts: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsCreateProduct
             * @request POST:/v1/products
             * @secure
             */
            productsCreateProduct: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsGetProduct
             * @request GET:/v1/products/{productId}
             * @secure
             */
            productsGetProduct: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateProduct
             * @request PUT:/v1/products/{productId}
             * @secure
             */
            productsUpdateProduct: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsDeleteResource
             * @request DELETE:/v1/products/{productId}
             * @secure
             */
            productsDeleteResource: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsActivateStatus
             * @request POST:/v1/products/{productId}/activate
             * @secure
             */
            productsActivateStatus: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsDeactivateStatus
             * @request POST:/v1/products/{productId}/deactivate
             * @secure
             */
            productsDeactivateStatus: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/deactivate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateProductBenefits
             * @request POST:/v1/products/{productId}/updateProductBenefits
             * @secure
             */
            productsUpdateProductBenefits: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateProductBenefits`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddProductBenefit
             * @request POST:/v1/products/{productId}/addProductBenefit/{benefitId}
             * @secure
             */
            productsAddProductBenefit: (productId, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/addProductBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveProductBenefit
             * @request POST:/v1/products/{productId}/removeProductBenefit/{benefitId}
             * @secure
             */
            productsRemoveProductBenefit: (productId, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/removeProductBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddTierBenefit
             * @request POST:/v1/products/{productId}/tiers/{tierName}/addBenefit/{benefitId}
             * @secure
             */
            productsAddTierBenefit: (productId, tierName, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/addBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveTierBenefit
             * @request POST:/v1/products/{productId}/tiers/{tierName}/removeBenefit/{benefitId}
             * @secure
             */
            productsRemoveTierBenefit: (productId, tierName, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/removeBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddSupplementBenefit
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/addBenefit/{benefitId}
             * @secure
             */
            productsAddSupplementBenefit: (productId, supplementInternalName, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/addBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveSupplementBenefit
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/removeBenefit/{benefitId}
             * @secure
             */
            productsRemoveSupplementBenefit: (productId, supplementInternalName, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/removeBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateSupplements
             * @request POST:/v1/products/{productId}/updateSupplements
             * @secure
             */
            productsUpdateSupplements: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateSupplements`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateInternalName
             * @request POST:/v1/products/{productId}/updateInternalName
             * @secure
             */
            productsUpdateInternalName: (productId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateInternalName`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateFriendlyNames
             * @request POST:/v1/products/{productId}/updateFriendlyNames
             * @secure
             */
            productsUpdateFriendlyNames: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateFriendlyNames`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateQualifyingDelegates
             * @request POST:/v1/products/{productId}/updateQualifyingDelegates
             * @secure
             */
            productsUpdateQualifyingDelegates: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateQualifyingDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateCategories
             * @request POST:/v1/products/{productId}/updateCategories
             * @secure
             */
            productsUpdateCategories: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateCategories`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateMarketingData
             * @request POST:/v1/products/{productId}/updateMarketingData
             * @secure
             */
            productsUpdateMarketingData: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateMarketingData`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateContracts
             * @request POST:/v1/products/{productId}/updateContracts
             * @secure
             */
            productsUpdateContracts: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddContract
             * @request POST:/v1/products/{productId}/addContract
             * @secure
             */
            productsAddContract: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/addContract`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveContract
             * @request POST:/v1/products/{productId}/removeContract/{locale}
             * @secure
             */
            productsRemoveContract: (productId, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/removeContract/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateContract
             * @request POST:/v1/products/{productId}/updateContract/{locale}
             * @secure
             */
            productsUpdateContract: (productId, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateContract/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddContractStateVariant
             * @request POST:/v1/products/{productId}/contracts/{locale}/addStateVariant
             * @secure
             */
            productsAddContractStateVariant: (productId, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/contracts/${locale}/addStateVariant`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveContractStateVariant
             * @request POST:/v1/products/{productId}/contracts/{locale}/removeStateVariant/{state}
             * @secure
             */
            productsRemoveContractStateVariant: (productId, locale, state, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/contracts/${locale}/removeStateVariant/${state}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateContractStateVariant
             * @request POST:/v1/products/{productId}/contracts/{locale}/updateStateVariant/{state}
             * @secure
             */
            productsUpdateContractStateVariant: (productId, locale, state, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/contracts/${locale}/updateStateVariant/${state}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateTierContracts
             * @request POST:/v1/products/{productId}/tiers/{tierName}/updateTierContracts
             * @secure
             */
            productsUpdateTierContracts: (productId, tierName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/updateTierContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddTierContract
             * @request POST:/v1/products/{productId}/tiers/{tierName}/addTierContract
             * @secure
             */
            productsAddTierContract: (productId, tierName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/addTierContract`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveTierContract
             * @request POST:/v1/products/{productId}/tiers/{tierName}/removeTierContract/{locale}
             * @secure
             */
            productsRemoveTierContract: (productId, tierName, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/removeTierContract/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateTierContract
             * @request POST:/v1/products/{productId}/tiers/{tierName}/updateTierContract/{locale}
             * @secure
             */
            productsUpdateTierContract: (productId, tierName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/updateTierContract/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddTierContractStateVariant
             * @request POST:/v1/products/{productId}/tiers/{tierName}/contracts/{locale}/addStateVariant
             * @secure
             */
            productsAddTierContractStateVariant: (productId, tierName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/contracts/${locale}/addStateVariant`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveTierContractStateVariant
             * @request POST:/v1/products/{productId}/tiers/{tierName}/contracts/{locale}/removeStateVariant/{state}
             * @secure
             */
            productsRemoveTierContractStateVariant: (productId, tierName, locale, state, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/contracts/${locale}/removeStateVariant/${state}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateTierContractStateVariant
             * @request POST:/v1/products/{productId}/tiers/{tierName}/contracts/{locale}/updateStateVariant/{state}
             * @secure
             */
            productsUpdateTierContractStateVariant: (productId, tierName, locale, state, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/contracts/${locale}/updateStateVariant/${state}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateSupplementContracts
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/updateSupplementContracts
             * @secure
             */
            productsUpdateSupplementContracts: (productId, supplementInternalName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/updateSupplementContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddSupplementContract
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/addSupplementContract
             * @secure
             */
            productsAddSupplementContract: (productId, supplementInternalName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/addSupplementContract`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveSupplementContract
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/removeSupplementContract/{locale}
             * @secure
             */
            productsRemoveSupplementContract: (productId, supplementInternalName, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/removeSupplementContract/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateSupplementContract
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/updateSupplementContract/{locale}
             * @secure
             */
            productsUpdateSupplementContract: (productId, supplementInternalName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/updateSupplementContract/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddSupplementContractStateVariant
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/contracts/{locale}/addStateVariant
             * @secure
             */
            productsAddSupplementContractStateVariant: (productId, supplementInternalName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/contracts/${locale}/addStateVariant`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveSupplementContractStateVariant
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/contracts/{locale}/removeStateVariant/{state}
             * @secure
             */
            productsRemoveSupplementContractStateVariant: (productId, supplementInternalName, locale, state, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/contracts/${locale}/removeStateVariant/${state}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateSupplementContractStateVariant
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/contracts/{locale}/updateStateVariant/{state}
             * @secure
             */
            productsUpdateSupplementContractStateVariant: (productId, supplementInternalName, locale, state, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/contracts/${locale}/updateStateVariant/${state}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateProductTiers
             * @request POST:/v1/products/{productId}/updateProductTiers
             * @secure
             */
            productsUpdateProductTiers: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateProductTiers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddFriendlyNameToTier
             * @request POST:/v1/products/{productId}/tiers/{tierName}/addFriendlyName
             * @secure
             */
            productsAddFriendlyNameToTier: (productId, tierName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/addFriendlyName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateFriendlyNameOnTier
             * @request POST:/v1/products/{productId}/tiers/{tierName}/updateFriendlyName/{locale}
             * @secure
             */
            productsUpdateFriendlyNameOnTier: (productId, tierName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/updateFriendlyName/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveFriendlyNameFromTier
             * @request POST:/v1/products/{productId}/tiers/{tierName}/removeFriendlyName/{locale}
             * @secure
             */
            productsRemoveFriendlyNameFromTier: (productId, tierName, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/removeFriendlyName/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddFriendlyNameToSupplement
             * @request POST:/v1/products/{productId}/supplements/{supplementName}/addFriendlyName
             * @secure
             */
            productsAddFriendlyNameToSupplement: (productId, supplementName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementName}/addFriendlyName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateFriendlyNameOnSupplement
             * @request POST:/v1/products/{productId}/supplements/{supplementName}/updateFriendlyName/{locale}
             * @secure
             */
            productsUpdateFriendlyNameOnSupplement: (productId, supplementName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementName}/updateFriendlyName/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveFriendlyNameFromSupplement
             * @request POST:/v1/products/{productId}/supplements/{supplementName}/removeFriendlyName/{locale}
             * @secure
             */
            productsRemoveFriendlyNameFromSupplement: (productId, supplementName, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementName}/removeFriendlyName/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateStateProvinceRestrictions
             * @request POST:/v1/products/{productId}/updateStateProvinceRestrictions
             * @secure
             */
            productsUpdateStateProvinceRestrictions: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateStateProvinceRestrictions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddStateProvinceRestriction
             * @request POST:/v1/products/{productId}/addStateProvinceRestriction
             * @secure
             */
            productsAddStateProvinceRestriction: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/addStateProvinceRestriction`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveStateProvinceRestriction
             * @request POST:/v1/products/{productId}/removeStateProvinceRestriction
             * @secure
             */
            productsRemoveStateProvinceRestriction: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/removeStateProvinceRestriction`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateAreaOfLawIds
             * @request POST:/v1/products/{productId}/updateAreaOfLawIds
             * @secure
             */
            productsUpdateAreaOfLawIds: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateAreaOfLawIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddAreaOfLawId
             * @request POST:/v1/products/{productId}/addAreaOfLawId
             * @secure
             */
            productsAddAreaOfLawId: (productId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/addAreaOfLawId`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveAreaOfLawId
             * @request POST:/v1/products/{productId}/removeAreaOfLawId/{areaOfLawId}
             * @secure
             */
            productsRemoveAreaOfLawId: (productId, areaOfLawId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/removeAreaOfLawId/${areaOfLawId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsVersionProduct
             * @request POST:/v1/products/{productId}/versionProduct
             * @secure
             */
            productsVersionProduct: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/versionProduct`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsGetProductVersion
             * @request GET:/v1/products/{productId}/productVersion/{productVersionId}
             * @secure
             */
            productsGetProductVersion: (productId, productVersionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/productVersion/${productVersionId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsJournal
             * @name ProductsJournalGetJournalChanges
             * @request GET:/v1/products/journal
             * @secure
             */
            productsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsJournal
             * @name ProductsJournalGetMaxClock
             * @request GET:/v1/products/journal/maxClock
             * @secure
             */
            productsJournalGetMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=products.js.map